<a href="javascript:void(0)" [name]="getAnchorName()"></a>
<div class="content">
  <ng-content></ng-content>
</div>
